import { application } from "../../app"
import "./components"
import "./form"

import CommandPaletteOpenerController from "./command_palette_opener_controller"
application.register("design-system--command-palette-opener", CommandPaletteOpenerController)

import ConfirmController from "./confirm_controller"
application.register("design-system--confirm", ConfirmController)

import ModalOpenerController from "./modal_opener_controller"
application.register("design-system--modal-opener", ModalOpenerController)

import SlideOverOpenerController from "./slide_over_opener_controller"
application.register("design-system--slide-over-opener", SlideOverOpenerController)

import TermSearcherController from "./term_searcher_controller"
application.register("design-system--term-searcher", TermSearcherController)
